import React, { useEffect } from 'react';
import { useSearchBox } from 'react-instantsearch-hooks-web';

export function CustomSearchBox(props: any) {
    const { keyword, setKeyword } = props;
    const { refine } = useSearchBox(props);

    useEffect(() => {
        if (keyword.length > 2) {
            refine(keyword);
        }
    }, [keyword]);

    return (
        <form>
            <label
                htmlFor="default-search"
                className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
                Search
            </label>
            <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-5 pointer-events-none">
                    <svg
                        aria-hidden="true"
                        className="w-5 h-5 text-gray-500 dark:text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        ></path>
                    </svg>
                </div>
                <input
                    type="search"
                    id="default-search"
                    className="block w-full p-6 pl-14 text-lg font-normal text-gray-900 focus-within:ring-0 focus-visible:ring-0 focus:shadow-xl rounded-2xl bg-primary-25"
                    placeholder="Search shop name, website, address..."
                    value={keyword}
                    onChange={(event) => setKeyword(event.target.value)}
                    required
                    autoFocus
                />
            </div>
        </form>
    );
}

